module.exports = __webpack_public_path__ + "static/assets/e4d0d9a3208286b26076af2ae20581c1.png";